import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'

import { THEME, typeScale } from '../../styles'

const Styled = styled.div`
  width: 100%;
`
Styled.table = styled.table`
  border: 0;
  width: 100%;
`
Styled.nutritionalFacts = styled.tbody``
Styled.nutritionalFactCell = styled.td`
  padding: 0;
  text-align: left;
  border: 0;

  &:last-child {
    text-align: right;
    font-weight: bold;
  }
`
Styled.nutritionalFact = styled.tr`
  border-bottom: 0.1rem dashed ${THEME.COLORS.foreground.secondary};

  &:last-child {
    border-bottom: 0;
  }
  ${Styled.nutritionalFactCell} {
    padding: 1.6rem 0;
  }
  &:first-child ${Styled.nutritionalFactCell} {
    padding-top: 0;
  }
  &:last-child ${Styled.nutritionalFactCell} {
    padding-bottom: 0;
  }
`
Styled.caption = styled.p`
  ${typeScale('caption')};
  color: ${THEME.COLORS.foreground.secondary};
  padding-top: 1.6rem;
`
Styled.nutrionalFactsHuman = styled(ReactMarkdown)`
  ${typeScale('caption', { textTransform: 'lowercase' })};
  color: ${THEME.COLORS.foreground.secondary};
  padding-top: 0.8rem;

  &:first-letter {
    text-transform: capitalize;
  }

  em {
    font-style: italic;
    text-transform: none;
  }
`

export default Styled
